import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, GiftIcon, ClockIcon, PlayCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const bonuses = [{
  name: 'Guía completa Macramé',
  image: 'https://cdn.magicpatterns.com/uploads/3KTeYvQbFy79AsKmpWVACP/Bono_1_Macrame.png'
}, {
  name: 'Pack de paleta de colores para tricotín',
  image: 'https://cdn.magicpatterns.com/uploads/sSxSKR6etc1qKmudsQRy28/Gemini_Generated_Image_9yrxys9yrxys9yrx.png'
}, {
  name: 'Guía de combinaciones de figuras más nombres',
  image: 'https://cdn.magicpatterns.com/uploads/iMi2m6RcMvy2Gfe5uZicgf/Gemini_Generated_Image_s8derds8derds8de.png'
}, {
  name: 'Cómo hacer bolígrafos con tricotín',
  image: 'https://cdn.magicpatterns.com/uploads/8mBZf4wQGMo3A7cVc2oktN/Gemini_Generated_Image_kt0ntokt0ntokt0n.png'
}, {
  name: '100 hojas prácticas diferentes diseños',
  image: 'https://cdn.magicpatterns.com/uploads/n9VwGAEwktgFQQis4XjjJt/Gemini_Generated_Image_5nma7w5nma7w5nma.png'
}, {
  name: 'Tabla de precios y control financiero',
  image: 'https://cdn.magicpatterns.com/uploads/rzZUuuTkwVWGic8XXvV9b1/Gemini_Generated_Image_iojunpiojunpioju.png'
}, {
  name: 'Moldes especiales de Navidad',
  image: 'https://cdn.magicpatterns.com/uploads/m7qaBZFpteE1uoEf1b6q4K/Gemini_Generated_Image_cg3i2cg3i2cg3i2c.png'
}, {
  name: 'Guía completa de 0 a tu primera pieza terminada',
  image: 'https://cdn.magicpatterns.com/uploads/7eGRmNfnBFYXo5NG4DLqwD/Gemini_Generated_Image_t4f4gt4f4gt4f4gt.png'
}, {
  name: 'Letras de tricotín',
  image: 'https://cdn.magicpatterns.com/uploads/8ob7Unih8FroKWbsZmRTxp/Bono_3_Letras_de_Tricotin.png'
}, {
  name: 'Moldes Premium',
  image: 'https://cdn.magicpatterns.com/uploads/78a8U6SsMPgSrTiMJJnbB7/Bono_10_Moldes_Premiun.png'
}];
export function OfferSection() {
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600).toString().padStart(2, '0');
  const minutes = Math.floor(timeLeft % 3600 / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <section id="oferta" className="py-24 bg-transparent relative overflow-hidden" data-id="element-100">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-mint/10 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2" data-id="element-101"></div>
      <div className="absolute top-1/2 right-0 w-64 h-64 bg-pink-soft/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-102"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="rounded-3xl p-1 bg-gradient-to-br from-mint via-white to-pink-soft shadow-2xl" data-id="element-104">
          <div className="bg-white rounded-[23px] p-6 md:p-10" data-id="element-105">
            <div className="text-center mb-10" data-id="element-106">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-107">
                Tu Kit Completo + 10 Bonos Exclusivos
              </h2>
              <div className="w-24 h-1 bg-mint mx-auto rounded-full" data-id="element-108"></div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6 mb-12" data-id="element-109">
              {bonuses.map((bonus, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col group" data-id="element-110">
                  <div className="relative aspect-square bg-cream flex items-center justify-center overflow-hidden" data-id="element-111">
                    <div className="absolute top-2 left-2 bg-mint text-dark font-bold text-xs w-6 h-6 rounded-full flex items-center justify-center shadow-md z-10" data-id="element-112">
                      {index + 1}
                    </div>
                    {bonus.image ? <img src={bonus.image} alt={bonus.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-113" /> : <GiftIcon className="w-12 h-12 text-mint/40 transition-transform duration-500 group-hover:scale-110 group-hover:text-mint/60" data-id="element-114" />}
                  </div>
                  <div className="p-3 md:p-4 flex flex-col flex-1" data-id="element-115">
                    <h4 className="font-bold text-dark text-xs md:text-sm mb-3 flex-1 leading-tight line-clamp-3" data-id="element-116">
                      {bonus.name}
                    </h4>
                    <div className="flex items-center justify-between mt-auto pt-2 border-t border-gray-100" data-id="element-117">
                      <span className="text-muted line-through text-xs md:text-sm" data-id="element-118">
                        €10
                      </span>
                      <span className="bg-rose/10 text-rose font-bold text-[10px] md:text-xs px-2 py-0.5 rounded-full" data-id="element-119">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="flex items-center justify-center gap-3 bg-gradient-to-r from-rose/5 via-rose/10 to-rose/5 border border-rose/20 rounded-2xl px-6 py-4 mb-10" data-id="element-120">
              <div className="bg-rose/15 p-2.5 rounded-full shrink-0" data-id="element-121">
                <PlayCircleIcon className="w-6 h-6 text-rose" data-id="element-122" />
              </div>
              <p className="text-dark font-bold text-sm md:text-base" data-id="element-123">
                🎬 También incluye{' '}
                <span className="text-rose" data-id="element-124">videos tutoriales paso a paso</span>{' '}
                para que aprendas de forma visual
              </p>
            </motion.div>

            <div className="text-center border-t border-gray-100 pt-10" data-id="element-125">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-126">
                <span className="text-2xl text-muted line-through font-medium" data-id="element-127">
                  €24,90
                </span>
                <span className="text-5xl md:text-6xl font-bold text-rose" data-id="element-128">
                  €9,90
                </span>
              </div>
              <p className="text-muted font-medium mb-6" data-id="element-129">
                Pago único · Acceso inmediato · Sin suscripciones
              </p>

              <div className="mb-8" data-id="element-130">
                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-131">
                  <ClockIcon className="w-4 h-4 text-rose animate-pulse" data-id="element-132" />
                  <span className="text-sm font-bold text-rose uppercase tracking-wider" data-id="element-133">
                    La oferta termina en
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2 text-rose font-bold text-2xl md:text-3xl" data-id="element-134">
                  <div className="bg-pink-soft/20 px-3 md:px-4 py-2 md:py-3 rounded-xl min-w-[56px] md:min-w-[70px]" data-id="element-135">
                    {hours}
                  </div>
                  <span className="text-pink-soft" data-id="element-136">:</span>
                  <div className="bg-pink-soft/20 px-3 md:px-4 py-2 md:py-3 rounded-xl min-w-[56px] md:min-w-[70px]" data-id="element-137">
                    {minutes}
                  </div>
                  <span className="text-pink-soft" data-id="element-138">:</span>
                  <div className="bg-pink-soft/20 px-3 md:px-4 py-2 md:py-3 rounded-xl min-w-[56px] md:min-w-[70px]" data-id="element-139">
                    {seconds}
                  </div>
                </div>
              </div>

              <a href="https://decomagickit.shop/cart/51109708955926:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-rose text-white font-bold text-lg md:text-xl px-10 py-5 rounded-full shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all animate-pulse-cta text-center" aria-label="Sí, quiero empezar mi negocio hoy" data-id="element-140">
                ¡SÍ, QUIERO EMPEZAR MI NEGOCIO HOY!
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}